import PropTypes from 'prop-types';
import React from 'react';

import { FaHeart } from 'react-icons/fa';

import { Color } from '../../../shared/constants/Colors';

import * as S from './Like.styles';

const Gradient = () => (
  <S.GradientWrapper>
    <svg height='0em' width='0em' padding='0em'>
      <linearGradient id='pink-gradient' x1='0' x2='0' y1='0' y2='100%'>
        <stop stopColor={Color.BRILLIANT_ROSE} />
        <stop offset='1' stopColor={Color.RAZZMATAZZ} />
      </linearGradient>
    </svg>
  </S.GradientWrapper>
);

export const Like = ({ isClicked, handleClick, isCounter, likes }) => (
  <>
    {isCounter ? (
      <S.Wrapper>
        {isClicked && <Gradient />}
        <S.HeartWrapper isLiked={isClicked}>
          <FaHeart />
        </S.HeartWrapper>
        {likes > 0 && <S.Counter>{likes}</S.Counter>}
      </S.Wrapper>
    ) : (
      <>
        {isClicked && <Gradient />}
        <S.LikeButton isLiked={isClicked} onClick={handleClick}>
          <FaHeart />
        </S.LikeButton>
      </>
    )}
  </>
);

Like.propTypes = {
  /**
   * Uptade the hearth icon if isClicked = true.
   */
  isClicked: PropTypes.bool,
  /**
   * Function triggered when clicking on the button.
   */
  handleClick: PropTypes.string,
  /**
   * If isCounter = true,
   */
  isCounter: PropTypes.bool,
  /**
   * Amount of like
   */
  likes: PropTypes.number,
};

Like.defaultProps = {
  isClicked: false,
  isCounter: false,
  likes: 0,
};
